/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Info_Att_SubtitleInputs */

const en_mobile_info_att_subtitle = /** @type {(inputs: Mobile_Info_Att_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow tracking to receive tailored recommendations and optimize your audio conversion journey.`)
};

const es_mobile_info_att_subtitle = /** @type {(inputs: Mobile_Info_Att_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite el seguimiento para recibir recomendaciones personalizadas y optimizar tu experiencia de conversión de audio.`)
};

/**
* | output |
* | --- |
* | "Allow tracking to receive tailored recommendations and optimize your audio conversion journey." |
*
* @param {Mobile_Info_Att_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_info_att_subtitle = /** @type {((inputs?: Mobile_Info_Att_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Info_Att_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_info_att_subtitle(inputs)
	return en_mobile_info_att_subtitle(inputs)
});